import axios from "axios";
import {
  apiRequest,
  ApiCalls,
} from "../../../components/forms/providerAppointmentForms/AllAppointmentsApi";
import { BenefitsSummaryResponse } from "./benefitsSummary.contract";

export * from "./benefitsSummary.contract";

// The caregiver is identified by the verified email in the Auth0 token, so
// the request body is empty.
export async function fetchBenefitsSummary(
  accessToken: string,
  signal?: AbortSignal
): Promise<BenefitsSummaryResponse> {
  const response = await axios.post<BenefitsSummaryResponse>(
    `${apiRequest}/${ApiCalls.GetBenefitsSummary}`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` }, signal }
  );
  return response.data;
}

export interface BenefitsTeamMessage {
  subject: string;
  message: string;
}

// Emails the benefits team. The server checks the child and plan belong to
// the signed-in caregiver and sets the caregiver's email as Reply-To.
export async function sendBenefitsTeamMessage(
  accessToken: string,
  request: BenefitsTeamMessage & { clientId: number; planId: string }
): Promise<void> {
  await axios.post(`${apiRequest}/${ApiCalls.MessageBenefitsTeam}`, request, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}
